
import { Currency } from '../../entities/control-tables/currency';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';



export class CurrencyRequest extends BaseRequest {

    currency : Currency

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.currency = new Currency()
  }
}